import { defineMessages } from 'react-intl';

export const messages: {
	jiraSearchWorkItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	jiraSearchWorkItems: {
		id: 'jira_advanced_search',
		defaultMessage: 'Search Jira for work items',
		description: 'Label for when the user wants to navigate to a advanced issue search on Jira',
	},
});
